/* eslint-disable react-native/no-inline-styles */
import { CustomHeader, Screen, Text } from "components"
import React, { useEffect, useState } from "react"
import { FlatList, TouchableOpacity, View, Image } from "react-native"
import { style } from "./styles"
import { useNavigation } from "@react-navigation/native"
import { translate } from "i18n"
import { colors } from "colors"
import { ActivityIndicator } from "react-native-paper"
import useResponsiveWidth from "components/fitSize"
import { useStores } from "models"
import { useSessionExpired } from "utils/function"
import { typography } from "theme"
import { useColor } from "app/theme/getThemes"
import flash from "config/flash"
import gamaIcon from "../../../../assets/gama-logo.png"

export const NotificationScreen = () => {
  const { sessionExpired } = useSessionExpired()
  const { userStore } = useStores()
  const { companyTheme } = useColor()
  const [loading, setLoading] = useState(false)
  const [notification, setNotification] = useState([])

  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()

  useEffect(() => {
    getNotification()
  }, [])

  const getNotification = async () => {
    setLoading(true)
    await fetch(`${process.env.API_URL}/api/notification/member/${userStore?.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setNotification(responseData)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const ReadAll = async () => {
    await fetch(`${process.env.API_URL}/api/notification/read`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
      body: JSON.stringify({
        member_id: userStore?.id,
      }),
    })
      .then(async (res) => {
        if (res?.ok) {
          flash("success", "You have read all message !")
          getNotification()
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const ReadSelected = async (item: any) => {
    if (item?.has_read === false) {
      await fetch(`${process.env.API_URL}/api/notification/read`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userStore?.accessToken}`,
        },
        body: JSON.stringify({
          notification_id: item?.notification_id,
          member_id: Number(userStore?.id),
        }),
      })
        .then(async (res) => {
          if (res?.ok) {
            getNotification()
          }
        })
        .catch((e) => {
          console.error(e)
        })
    }
  }

  return (
    <>
      <CustomHeader headerTitle={"Notification"} height={100} showBackButton withBalls />
      <Screen>
        <View style={[style.container, { width }]}>
          <TouchableOpacity
            onPress={() => {
              ReadAll()
            }}
          >
            <Text
              style={{
                alignSelf: "flex-end",
                textDecorationLine: "underline",
                color: colors.errorText,
                fontFamily: typography.primary.normal,
                fontWeight: "bold",
              }}
            >
              Mark all as read
            </Text>
          </TouchableOpacity>

          <FlatList
            showsVerticalScrollIndicator={false}
            data={notification}
            contentContainerStyle={style.flex}
            style={style.flatList}
            ListFooterComponent={() => {
              return <View style={{ height: 150, width: "100%" }} />
            }}
            ListEmptyComponent={() => {
              return (
                <View style={style.emptyContainer}>
                  {loading ? (
                    <ActivityIndicator size="large" color={companyTheme.first} />
                  ) : (
                    <>
                      <Text style={style.emptyTitle}>
                        {translate("promotionScreen.noNotification")}
                      </Text>
                      <Text>{translate("promotionScreen.stayTunedNoti")}</Text>
                    </>
                  )}
                </View>
              )
            }}
            renderItem={({ item }) => {
              return (
                <TouchableOpacity
                  style={style.contentContainer}
                  onPress={() => {
                    ReadSelected(item)
                  }}
                >
                  {item.notification_image_url ? (
                    <View style={style.imageContainer}>
                      <Image
                        source={item?.notification_image_url}
                        style={[style.image, { width: width * 0.2, height: width * 0.2 }]}
                      />
                    </View>
                  ) : (
                    <View style={style.imageContainer}>
                      <Image
                        source={gamaIcon}
                        style={[style.image, { width: width * 0.2, height: width * 0.2, resizeMode:'contain' }]}
                      />
                    </View>
                  )}
                  <View style={style.contentTitleText}>
                    <Text numberOfLines={1}>{item?.notification_title}</Text>
                    <Text numberOfLines={3} style={{ fontSize: 12 }}>
                      {item?.notification_body}
                    </Text>
                  </View>

                  {!item?.has_read && (
                    <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
                      <View
                        style={{ backgroundColor: "red", height: 10, width: 10, borderRadius: 100 }}
                      />
                    </View>
                  )}
                </TouchableOpacity>
              )
            }}
          />
        </View>
      </Screen>
    </>
  )
}
